import React from 'react'

import PropTypes from 'prop-types'
import {Redirect} from 'react-router-dom'
import {useSelector} from 'react-redux'

import {makeStyles} from '@material-ui/core/styles'
import {AppBar, Container, Tab, Tabs} from '@material-ui/core'
import Box from "@material-ui/core/Box";

import Page from 'components/Page/Page'

import Machines from './Machines.js'
import Sites from './Sites.js'
import Ecocontrols from './Ecocontrols'
import Cashdrawers from "./Cashdrawers";
import Employees from './Employees.js'
import ScrapRefundates from './ScrapRefundrates.js'
import NFCTokens from './NFCTokens.js'
import Ecosacks from './Ecosacks.js'
import FeePolicies from './FeePolicies.js'
import LogoPolicies from './LogoPolicies.js'
import Subaccounts from './Subaccounts.js'

const useStyles = makeStyles((theme) => ({}))

const SettingsPage = ({children}) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  if (!auth.access_token) {
    return <Redirect to="/login"/>
  }

  function hasPermission(perm) {
    for (var i = 0; i < auth.permissions.length; i++) {
      if (auth.permissions[i][0] == perm[0] && auth.permissions[i][1] == perm[1]) {
        return true
      }
    }
    return false
  }

  return (
    <Page title="ScrapRefundrates">
      <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="scrollable">
            <Tab label="Sites"/>
            <Tab label="Devices"/>
            <Tab label="Ecocontrols"/>
            <Tab label="Cashdrawers"/>
            <Tab label="Employees"/>
            <Tab label="ScrapRefundrates"/>
            <Tab label="NFC Tokens"/>
            <Tab label="Ecosacks"/>
            <Tab label="Fee Policies"/>
            <Tab label="Sub-accounts"/>
            <Tab label="Logo Policies"/>
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          {hasPermission(["Admin", "admin"]) &&
            <Sites/>
          }
        </TabPanel>

        <TabPanel value={value} index={1}>
          {hasPermission(["Admin", "admin"]) &&
            <Machines/>
          }
        </TabPanel>

        <TabPanel value={value} index={2}>
          {hasPermission(["Admin", "admin"]) &&
            <Ecocontrols/>
          }
        </TabPanel>

        <TabPanel value={value} index={3}>
          {hasPermission(["Admin", "admin"]) &&
            <Cashdrawers/>
          }
        </TabPanel>

        <TabPanel value={value} index={4}>
          {hasPermission(["Admin", "admin"]) &&
            <Employees/>
          }
        </TabPanel>

        <TabPanel value={value} index={5}>
          {hasPermission(["Admin", "admin"]) &&
            <ScrapRefundates/>
          }
        </TabPanel>

        <TabPanel value={value} index={6}>
          {hasPermission(["Admin", "admin"]) &&
            <NFCTokens/>
          }
        </TabPanel>
          
        <TabPanel value={value} index={7}>
          {hasPermission(["Admin", "admin"]) &&
            <Ecosacks/>
          }
        </TabPanel>

        <TabPanel value={value} index={8}>
          {hasPermission(["Admin", "admin"]) &&
            <FeePolicies/>
          }
        </TabPanel>

        <TabPanel value={value} index={9}>
          {hasPermission(["Admin", "admin"]) &&
            <Subaccounts/>
          }
        </TabPanel>

        <TabPanel value={value} index={10}>
          {hasPermission(["Admin", "admin"]) &&
            <LogoPolicies/>
          }
        </TabPanel>

      </Container>
    </Page>
  )
}

export default SettingsPage

SettingsPage.propTypes = {
  children: PropTypes.node
}
